module.exports = __webpack_public_path__ + "img/thumb-004-11.c4b6f61c.png";